const Summary = ({ children }: React.PropsWithChildren) => {
    return (
        <div className="my-5">
            <p className="font-bold text-xl md:text-2xl mb-5">Summary:</p>
            <div className="border-l-4 border-primary pl-3 text-lg">{children}</div>
        </div>
    );
};

export default Summary;
